import C from './Constants';
function isReconcilableBusinessState(businessState, allowAvailable = false) {
  const toReturn = businessState === C.BUSINESS_STATES.SUPPORT_REQUIRED || businessState === C.BUSINESS_STATES.LOST;
  if (allowAvailable) {
    return toReturn || businessState === C.BUSINESS_STATES.AVAILABLE;
  }
  return toReturn;
}
function isReconcilableOperationState(operationState) {
  const toReturn = operationState === C.OPERATION_STATES.LM_IDLE || operationState === C.OPERATION_STATES.TR_IDLE;
  return toReturn;
}
export { isReconcilableBusinessState, isReconcilableOperationState };